<div class="lost-phone-banner-wrapper">
  <app-banner bannerType="v2-light-blue" bannerName="lost-phone" [showClose]="false">
    <div class="lost-phone-content">
      <ci-phosphor-icon name="info" variant="info" size="lg" />
      <div class="lost-phone-text">
        <div class="lost-phone-title">Lost your phone?</div>
        <div class="lost-phone-subtitle">
          Contact your administrator and ask them to reset the authentication preferences on your account.
        </div>
      </div>
    </div>
  </app-banner>
</div>
